import React from "react";
import Button from "components/Button";

const ParticipantAutoFillPopup = ({
  open,
  options,
  setOptions,
  onConfirm,
  onCancel,
  isEdit,
}) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-xl shadow-lg max-w-lg w-full mx-4 md:mx-0">
        <div className="mb-4">
          <h2 className="text-lg font-bold pb-1">
            {/* Auto-fill Participant Details */}
            {isEdit
              ? "Update Participant Details"
              : "Auto-fill Participant Details"}
          </h2>
          <p className="text-xs text-primary">
            {isEdit ? (
              <>
                <p>
                  Select the information you want to refresh using the main
                  traveler’s latest details. Only the selected fields will be
                  replaced for this participant.
                </p>

                <p className="text-xs text-red-600 font-medium pt-2">
                  <span className="text-secondary font-medium">Note:</span> If
                  changes are made, click Confirm. If no changes are made, click
                  Cancel and then click Update to proceed.
                </p>
              </>
            ) : (
              "Choose the information you want to copy from the main traveler’s details to this new participant. This helps you avoid entering the same information manually."
            )}
          </p>
        </div>

        {["address", "airTravel"].map((field) => (
          <label
            key={field}
            className="flex items-center gap-2 text-sm font-medium text-activeTabColor cursor-pointer mb-2"
          >
            <input
              type="checkbox"
              checked={options[field]}
              onChange={(e) =>
                setOptions((prev) => ({ ...prev, [field]: e.target.checked }))
              }
            />
            {field === "address" && "Address"}
            {field === "airTravel" && "Air Travel Details"}
          </label>
        ))}

        <div className="flex items-center justify-end gap-4 mt-10">
          <Button
            className="w-fit h-fit text-sm font-medium text-buttonColor bg-transparent border border-buttonColor"
            onClick={onCancel}
            text="Cancel"
          />
          <Button
            className="w-fit h-fit text-sm font-medium text-white bg-buttonColor"
            onClick={onConfirm}
            text="Confirm"
          />
        </div>
      </div>
    </div>
  );
};

export default ParticipantAutoFillPopup;
